import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../atomic/Loader/Loader";
import Panel from "../../atomic/Panel/Panel";
import FloatingButton from "../../atomic/FloatingButton/FloatingButton";
import { Route, Switch, useParams, Redirect } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import { Link } from "react-router-dom";
import Button from "../../atomic/Button/Button";
import {
  getBlogs,
  isLoading,
  loadUserBlogsAction,
  saveBlogAction,
  isSaving
} from "../../../state/blogs";
import Layout from "../../containers/Layout/Layout";
import BlogsTable from "../../partials/BlogsTable/BlogsTable";
import { OneBlogPage } from "../OneBlogPage/OneBlogPage";
var slugify = require("slugify");

export function generateId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const ConfirmDiv = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Buttons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const Divider = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DeleteBlog = () => {
  const { blogId } = useParams();
  const [requireRedirect, setRequireRedirect] = useState(false);
  const dispatch = useDispatch();
  const saving = useSelector(isSaving);
  useEffect(() => {
    if (saving) {
      setRequireRedirect(true);
    }
  }, [saving]);
  if (!saving && requireRedirect) {
    return <Redirect to="/posts" />;
  }
  if (saving) {
    return <Loader />;
  }
  return (
    <ConfirmDiv>
      <div>Are you sure you want to delete this post?</div>
      <Buttons>
        <Link to="/posts">
          <Button>Cancel</Button>
        </Link>
        <Button
          inverted
          onClick={() =>
            dispatch(saveBlogAction({ id: blogId, status: "deleted" }))
          }
        >
          Delete
        </Button>
      </Buttons>
    </ConfirmDiv>
  );
};

const PublishBlog = () => {
  const { blogId } = useParams();
  const [requireRedirect, setRequireRedirect] = useState(false);
  const dispatch = useDispatch();
  const saving = useSelector(isSaving);
  const blogs = useSelector(getBlogs);
  useEffect(() => {
    if (saving) {
      setRequireRedirect(true);
    }
  }, [saving]);
  if (!saving && requireRedirect) {
    return <Redirect to="/posts" />;
  }
  if (saving) {
    return <Loader />;
  }
  const blog = blogs.filter(b => b.id === blogId)[0];
  const slug = slugify(blog.title, {
    remove: /[?*+~.()'"!:@]/g,
    lower: true
  });
  return (
    <ConfirmDiv>
      <div>Submit the post for review.</div>
      <Buttons>
        <Link to="/posts">
          <Button>Cancel</Button>
        </Link>
        <Button
          inverted
          onClick={() =>
            dispatch(saveBlogAction({ ...blog, status: "In Review", slug }))
          }
        >
          Publish
        </Button>
      </Buttons>
    </ConfirmDiv>
  );
};

const BlogsPage = ({}) => {
  const blogs = useSelector(getBlogs);
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const newLocId = generateId();
  useEffect(() => {
    if (!blogs) {
      dispatch(loadUserBlogsAction());
    }
  }, []);
  if (!blogs || loading) {
    return <Loader />;
  }
  return (
    <Layout>
      <Switch>
        <Route path="/posts" exact>
          <h1>Posts</h1>
          <Panel>
            <BlogsTable blogs={blogs} />
          </Panel>
        </Route>
        <Route path="/post/edit/:blogId">
          <OneBlogPage />
        </Route>
        <Route path="/posts/delete/:blogId">
          <DeleteBlog />
        </Route>
        <Route path="/posts/publish/:blogId">
          <PublishBlog />
        </Route>
      </Switch>
      <FloatingButton
        link={"/post/edit/" + newLocId}
        icon="plus"
      ></FloatingButton>
    </Layout>
  );
};

export default BlogsPage;
